import { QUERY_CURRENT_POST } from '~/app/state/queries'
import { getCachedData, setCachedData } from '~/shared/utils'

/**
 *
 */
// @ts-expect-error TS(7006) FIXME: Parameter '_' implicitly has an 'any' type.
export default async function setCurrentPost(_, { currentPost }, { client }) {
  const { currentPost: savedPost } =
    getCachedData(client, {
      query: QUERY_CURRENT_POST,
    }) || {}

  const updatedPost = {
    ...savedPost,
    ...currentPost,
  }

  if (currentPost?.channelServiceId) {
    updatedPost.channelId = currentPost.channelServiceId
  }

  setCachedData(client, {
    query: QUERY_CURRENT_POST,
    data: {
      currentPost: currentPost
        ? {
            __typename: 'CurrentPost',
            id: updatedPost.id,
            channelId: updatedPost.channelId,
            engageCompleted: currentPost.engageCompleted || false,
            totalPendingComments: updatedPost.totalPendingComments,
            createdAt: updatedPost.createdAt,
            commentsUpdatedAt: updatedPost.commentsUpdatedAt,
            fallbackImg: updatedPost.fallbackImg || null,
          }
        : null,
    },
  })
}
